import script from "./TutorExperiencesForm.vue?vue&type=script&setup=true&lang=js"
export * from "./TutorExperiencesForm.vue?vue&type=script&setup=true&lang=js"

import "./TutorExperiencesForm.vue?vue&type=style&index=0&id=bc49cfc4&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-bc49cfc4"]])

export default __exports__